import { Directive, ElementRef, OnDestroy } from '@angular/core';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';

@Directive({ selector: '[appMrasMaskDate]' })
export class MrasMaskDateDirective implements OnDestroy {

    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // dd/mm/yyyy
    maskedInputController;

    constructor(private element: ElementRef) {
        this.maskedInputController = textMask.maskInput({
            inputElement: this.element.nativeElement,
            mask: this.mask
        });
    }

    ngOnDestroy() {
        this.maskedInputController.destroy();
    }
}


@Directive({ selector: '[appMrasMaskDate2]' })
export class MrasMaskDate2Directive implements OnDestroy {

    mask = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // mm/yyyy
    maskedInputController;

    constructor(private element: ElementRef) {
        this.maskedInputController = textMask.maskInput({
            inputElement: this.element.nativeElement,
            mask: this.mask
        });
    }

    ngOnDestroy() {
        this.maskedInputController.destroy();
    }
}